export const DEFAULT_CURRENCY = 'EUR';
export const DEFAULT_LOCALE = 'en-nl';
export const DEFAULT_TIME_ZONE = 'Europe/Amsterdam';

export const PRE_ORDER_DEADLINE = new Date('2025-12-31T23:59:00+02:00'); // 31st December at 11:59 PM in Europe/Amsterdam Winter Time
export const DELIVERY_DATE = '2025-10-21';

export const CUSTOMER_SUPPORT_LINK = '/support/contact-form';

export const MIND_OASIS_APP_STORE_ID = 'mind-oasis/id6747341418';
export const MIND_OASIS_PLAY_STORE_ID = 'com.rituals.mindoasis';

export const TERMS_AND_CONDITIONS_URL =
  '/support/general?question=mind-oasis-general-terms-and-conditions';
export const PRIVACY_POLICY_URL = '/support/general?question=privacy-policy';
